import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';
interface INavBarProps extends TestingProps {
  children?: React.ReactNode;
  className?: string;
}

export const NavBar: React.FunctionComponent<INavBarProps> = (props) => {
  return (
    <ul className={C('navbar-nav', props.className)} data-testid={props.testId}>
      {props.children}
    </ul>
  );
};
